<template>
    <div class="app-contact">
        <top-hero :heroImage="heroImage" :heroTitle="title"></top-hero>

        <!-- Main content -->
        <div class="row no-gutters contact-padding">
            <div class="left-contact left-bg col-md-6 px-7 py-7">

                <div class="left-contact-content mb-4">
                    <small>LET’S WORK TOGETHER</small>
                    <h1 class=" header-text">Leave Us a Message</h1>
                    <p>Please let us know how we can assist you by completing the form below and we will gladly get back to you as soon as possible!</p>
                </div>

                <div id="contact-form">
                    <contact-form purppse="contact-form"></contact-form>
                </div>
            </div>

            <div class="right-contact right-bg col-md-3 px-5 py-7">
			
               <div class="vc_column-inner"><div class="wpb_wrapper">	

                <h4 style="font-size: 30px; line-height: 40px; letter-spacing: 0px;"><strong>Accra, Ghana  Office</strong></h4>

                <div id="www" class=" noanimation " data-animation="No Animation" data-delay="500"><div class="zolo_gradient_icon_wrap">
                    <div class="zolo_gradient_icon"><i class="fa fa-map-marker"></i></div></div>
                    <div class="zolo_gradient_content_wrap">
                        <h4 class="zolo_gradient_icon_title" style="font-size: 18px; line-height: 22px; letter-spacing: 0px; ">
                            <strong>HSE #C7/14 Dzorwulu</strong><br>
                Accra, Ghana<br>
                </h4></div></div>

                <div class="apress-spacer" data-height-mobile-landscape="" style="clear:both;display:block;"></div>	

                <div id="wqw" class=" noanimation " data-animation="No Animation" data-delay="500">
                    <div class="zolo_gradient_icon_wrap"><div class="zolo_gradient_icon"><i class="fa fa-phone"></i></div></div>
                    <div class="zolo_gradient_content_wrap">
                        <h4 class="zolo_gradient_icon_title" style="font-size: 18px; line-height: 22px; letter-spacing: 0px; ">
                            Call us<br>+233(0)206360997</h4>
                    </div></div>

                <div class="apress-spacer" data-id="" data-height-mobile-landscape="" style="clear:both;display:block;"></div>	

                <div id="wer" class=" noanimation " data-animation="No Animation" data-delay="500">
                    <div class="zolo_gradient_icon_wrap"><div class="zolo_gradient_icon"><i class="fa fa-envelope-o"></i></div></div>
                    <div class="zolo_gradient_content_wrap">
                        <h4 class="zolo_gradient_icon_title" style="font-size: 18px; line-height: 22px; letter-spacing: 0px; ">Email us<br>
                info@molawconsult.com <br> ematekole@molawconsult.com</h4></div></div>

                <div class="apress-spacer" data-id="" data-height-mobile-landscape="" style="clear:both;display:block;"></div>	

                <div id="wqw" class=" noanimation " data-animation="No Animation" data-delay="500">
                    <div class="zolo_gradient_icon_wrap"><div class="zolo_gradient_icon"><i class="fa fa-pencil"></i></div></div>
                    <div class="zolo_gradient_content_wrap">
                        <h4 class="zolo_gradient_icon_title" style="font-size: 18px; line-height: 22px; letter-spacing: 0px; ">
                           Working Hours:<br> Mon to Sun - 9:00am to 6:00pm</h4>
                    </div></div>

			</div></div>		
			
			</div>
			
            <div class="right-contact right-bg col-md-3 px-5 py-7">
			
               <div class="vc_column-inner"><div class="wpb_wrapper">	

                                   <h4 style="font-size: 30px; line-height: 40px; letter-spacing: 0px;"><strong>Dubai, UAE Office</strong></h4>



 <div id="www" class=" noanimation " data-animation="No Animation" data-delay="500"><div class="zolo_gradient_icon_wrap">
                    <div class="zolo_gradient_icon"><i class="fa fa-map-marker"></i></div></div>
                    <div class="zolo_gradient_content_wrap">
                        <h4 class="zolo_gradient_icon_title" style="font-size: 18px; line-height: 22px; letter-spacing: 0px; ">
                            <strong>Al Zarooni Business Center, Al Barsha 1</strong><br>
Office 308<br>
Dubai, UAE<br>
PO Box 50262
                </h4></div></div>


                <div class="apress-spacer" data-height-mobile-landscape="" style="clear:both;display:block;"></div>	

                <div id="wqw" class=" noanimation " data-animation="No Animation" data-delay="500">
                    <div class="zolo_gradient_icon_wrap"><div class="zolo_gradient_icon"><i class="fa fa-phone"></i></div></div>
                    <div class="zolo_gradient_content_wrap">
                        <h4 class="zolo_gradient_icon_title" style="font-size: 18px; line-height: 22px; letter-spacing: 0px; ">
                            Call us<br>+971 454 70228</h4>
                    </div></div>

                <div class="apress-spacer" data-height-mobile-landscape="" style="clear:both;display:block;"></div>	

 <div id="wqw" class=" noanimation " data-animation="No Animation" data-delay="500">
                    <div class="zolo_gradient_icon_wrap"><div class="zolo_gradient_icon"><i class="fa fa-whatsapp"></i></div></div>
                    <div class="zolo_gradient_content_wrap">
                        <h4 class="zolo_gradient_icon_title" style="font-size: 18px; line-height: 22px; letter-spacing: 0px; ">
                            Chat With Us<br>+971 52 2319 569</h4>
                    </div></div>
                <div class="apress-spacer" data-height-mobile-landscape="" style="clear:both;display:block;"></div>	


<div id="wer" class=" noanimation " data-animation="No Animation" data-delay="500">
                    <div class="zolo_gradient_icon_wrap"><div class="zolo_gradient_icon"><i class="fa fa-envelope-o"></i></div></div>
                    <div class="zolo_gradient_content_wrap">
                    <h4 class="zolo_gradient_icon_title" style="font-size: 18px; line-height: 22px; letter-spacing: 0px; ">
                            Email us<br>
                 info@thelmgconsultants.com</h4></div></div>      

                 


</div></div>

            

            </div>
        </div>

        <!-- Map -->
        <div>
            
            <iframe :src="'https://maps.google.com/maps?q='+map.lat+','+map.lon+'&hl=en&z=14&amp;output=embed'" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
        </div>
    </div>
</template>

<script>
let heroImage = require('@/assets/img/hero/contact.jpg');
import TopHero from '@/components/frontend/Hero.vue';
import ContactForm from '@/components/ContactForm.vue';
import axios from 'axios';

export default {
    components: {
        TopHero,
        ContactForm 
    },
    name: 'Contact',
    data() {
        return {
            title: 'Contact Us',
            heroImage: heroImage,
            contact: {
                name: '',
                email: '',
                message: ''
            },
            map: {
                lat: 5.609206,
                lon: -0.209833
            }
        };
    },
    metaInfo() {
        return {
            title: this.title
        };
    },
    methods: {}
};
</script>






// WEBPACK FOOTER //
// src/views/frontend/Contact.vue